import UploadIcon from '@mui/icons-material/Upload';
import { type BoxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import { Tooltip } from '@/components/ui/tooltip';
import { usePrefValue } from '@/preferences';
import { ImportButton } from './ImportScript.styles';

export const ImportScriptButton = (props: BoxProps) => {
    const { t } = useTranslation();
    const side_bar = usePrefValue('side_bar');

    // Disabled until import functionality is implemented
    const disabled = true;

    return (
        <ImportButton sideBar={side_bar} disabled={disabled} {...props}>
            {side_bar ? (
                <>
                    <UploadIcon fontSize="small" />
                    <Text variant="body2" color="text-inherit" children={t('import.import-script')} />
                </>
            ) : (
                <Tooltip
                    title={<Typography variant="body2" color={theme => theme.custom.c22} children={t('import.import-script')} />}
                    disableInteractive
                    placement="left"
                    sideOffset={8}
                    contentClassName="py-2 pr-3 pl-0 bg-bg-paper"
                >
                    <div className="flex">
                        <UploadIcon fontSize="small" />
                    </div>
                </Tooltip>
            )}
        </ImportButton>
    );
};
